/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ClassroomdisciplineSharedClassStudents200,
  GetApiV1ClassroomdisciplineSharedClassStudents401,
  GetApiV1ClassroomdisciplineSharedClassStudentsQueryParams,
  GetApiV1ClassroomdisciplineSharedClassStudentsQueryResponse,
} from "../../types/classPlanningSharedController/GetApiV1ClassroomdisciplineSharedClassStudents.ts";
import { dropDownListViewModelSchema } from "../dropDownListViewModelSchema.ts";

export const getApiV1ClassroomdisciplineSharedClassStudentsQueryParamsSchema = z
  .object({
    Search: z.optional(z.string()),
    Take: z.optional(z.coerce.number().int()),
    Culture: z.optional(z.string()),
    CourseId: z.optional(z.coerce.number().int()),
  })
  .optional() as unknown as ToZod<GetApiV1ClassroomdisciplineSharedClassStudentsQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ClassroomdisciplineSharedClassStudents200Schema = z.array(
  z.lazy(() => dropDownListViewModelSchema),
) as unknown as ToZod<GetApiV1ClassroomdisciplineSharedClassStudents200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ClassroomdisciplineSharedClassStudents401Schema =
  z.any() as unknown as ToZod<GetApiV1ClassroomdisciplineSharedClassStudents401>;

export const getApiV1ClassroomdisciplineSharedClassStudentsQueryResponseSchema =
  z.lazy(
    () => getApiV1ClassroomdisciplineSharedClassStudents200Schema,
  ) as unknown as ToZod<GetApiV1ClassroomdisciplineSharedClassStudentsQueryResponse>;
